import Reveal from "@/components/base/Reveal";

export interface FeatureItem {
  icon: string;
  title: string;
  text: string;
}

interface FeatureGridProps {
  items: FeatureItem[];
  columns?: 2 | 3;
}

const columnClasses: Record<2 | 3, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
};

const tones = [
  "bg-primary-100 text-primary-700 ring-primary-300/60",
  "bg-accent-100 text-accent-700 ring-accent-300/60",
  "bg-secondary-100 text-secondary-800 ring-secondary-300/60",
];

export default function FeatureGrid({ items, columns = 3 }: FeatureGridProps) {
  return (
    <div className={`grid grid-cols-1 gap-5 ${columnClasses[columns]}`}>
      {items.map((item, index) => (
        <Reveal key={item.title} delay={index * 70}>
          <article className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 md:p-7">
            <span
              className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
              aria-hidden="true"
            />
            <span
              className="pointer-events-none absolute right-5 top-4 font-heading text-4xl font-medium leading-none text-background-200 transition-colors duration-300 group-hover:text-accent-200"
              aria-hidden="true"
            >
              {String(index + 1).padStart(2, "0")}
            </span>
            <span
              className={`relative flex h-11 w-11 items-center justify-center rounded-lg ring-1 ring-inset ${
                tones[index % 3]
              }`}
            >
              <i className={`${item.icon} text-xl`} aria-hidden="true" />
            </span>
            <h3 className="relative mt-4 font-heading text-base font-medium tracking-tight text-foreground-950">
              {item.title}
            </h3>
            <p className="relative mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
          </article>
        </Reveal>
      ))}
    </div>
  );
}